import styled from '@emotion/styled';
import type { MicrositeVideoData } from '~/model';
import MicrositeVideo from '~/components/MicrositeVideo';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const Title = styled.h2`
	font-size: 2rem;
	text-transform: uppercase;
	margin-bottom: 1.5rem;
`;

const Player = styled.div`
	max-width: 96rem;
	margin: 0 auto;
	aspect-ratio: 16 / 9;
	background: black;
`;

export default function VideoBlockZeta({ title, video }: { title: string; video: MicrositeVideoData }) {
	return (
		<Section id="media">
			<Title>{title}</Title>
			<Player>
				<MicrositeVideo video={video} />
			</Player>
		</Section>
	);
}
